import { useQuery, UseQueryExecute } from "urql";
import { SongFieldsFragmentDoc, SongUb } from "../../gql/graphql";
import { graphql, useFragment } from "../../gql";

const songQuery = graphql(`
  query songQuery($bucket: String!, $id: ID!) {
    song(bucket: $bucket, id: $id) {
      ...SongFields
    }
  }
`);

export function useSongQuery(
  bucket: string,
  songId: string,
): {
  songMaybe: SongUb | undefined;
  fetching: boolean;
  reexecuteQuery: UseQueryExecute;
} {
  const [result, reexecuteQuery] = useQuery({
    query: songQuery,
    variables: { bucket, id: songId },
    // requestPolicy: "cache-and-network"
  });

  const { data, fetching } = result;

  // Unmask the fragment data using useFragment
  const song = useFragment(SongFieldsFragmentDoc, data?.song);

  return {
    songMaybe: song ?? undefined,
    fetching: fetching,
    reexecuteQuery,
  };
}
